export async function getRegistrationPath(self) {
    self.$HttpClient.commonService.url = "Applicant/GetRegistrationPath";
    self.$HttpClient.commonService.get()
        .then(r => r.json())
        .then(json => {
            self.applicantURL = json.applicantURL;
        });
}